import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { academyusergetdetail, noticount } from "../service/dashboard";
import PrivateRoute from "./privateroute";

const Header = () => {
  const staticLogo = require("../assets/images/logo/tracking-logo.png");
  const [ncnt, setNCnt] = useState(0);
  const [nlist, setNList] = useState([]);
  const [elogo, setElogo] = useState(staticLogo);
  const navigate = useNavigate();

  useEffect(() => {
    noticount().then((res) => {
      if (res.status === true) {
        setNCnt(res.data.unread_count);
      }
    });

    academyusergetdetail(localStorage.getItem("UID")).then((res) => {
      if (res?.status) {
        const logo = res.data?.details?.logo;
        if (logo) {
          setElogo(res.data.path + logo);
        }
      }
    });
  }, []);

  return (
    <div className="mainhead">
      <PrivateRoute />
      <div className="dash-head">
        <Row className="row-sm">
          <div className="col-6 pl-0 text-center">
            <img
              src={elogo}
              alt="dash-logo"
              className="dash-logo"
              onError={(ev) => { ev.target.src = staticLogo; ev.target.onerror = null; }}
              onClick={() => navigate("/dashboard")}
            />
          </div>
          <div className="col-6 align-self-end">
            <i
              className="fa-solid fa-rotate-right refreshicon"
              title="Refresh"
              onClick={() => window.location.reload()}
            ></i>
            <span onClick={() => navigate("/notification")} style={{ position: "relative" }}>
              <i className="fa-solid fa-bell bellicon"></i>
              {ncnt !== 0 && <span className="num-count">{ncnt}</span>}
            </span>
          </div>
        </Row>
      </div>
      <hr className="mb-0" />
    </div>
  );
};

export default Header;
